/**
 * Calculator
 * ======================================
 * - config is loaded from json file located in define/calculator_config.json
 */

export class Calculator {
  constructor() {
    this.calculator = document.querySelector('#calculator')

    if(!this.calculator){
      return
    }

    this.default_type = calculator_config.types.legacy
    this.form = calculator.querySelector('form')
    this.type_inputs = calculator.querySelectorAll('input[name=type]')
    this.account_value_inputs = calculator.querySelectorAll('input[name="account_value"]')
    this.challenge_step1_input = calculator.querySelector('input#challenge1')
    this.challenge_step2_input = calculator.querySelector('input#challenge2')

    this.type_inputs.forEach((el) => {
      el.addEventListener("input", this.bindTypeChange)
    })

    this.form.addEventListener("input", this.bindFormChange)

    // set default data
    this.setAccountSizeValues(this.default_type)
    this.setResults(this.default_type.results.steps_1)
  }

  bindFormChange = (e) => {
    const form_data = new FormData(e.currentTarget)
    const type = form_data.getAll('type');
    const challenge = form_data.getAll('challenge');

    this.setResults(calculator_config.types[type].results[challenge])
  }

  setResults = (data) => {
    const account_value = this.calculator.querySelector('input[name="account_value"]:checked').value
    const fee = data.fee[account_value]

    this.setResult('profit_share', data.profit_share)
    this.setResult('profit_target', data.profit_target)
    this.setResult('loss_limit', data.loss_limit)
    this.setResult('leverage', data.leverage)
    this.setResult('max_trailing', data.max_trailing)
    this.setResult('fee', fee)
  }

  setResult = (name, value) => {
    const target = this.calculator.querySelector('.calculator__info-value[calculator-result='+name+']')

    target.innerHTML = value
  }

  bindTypeChange = (e) => {
    const el = e.currentTarget

    if(el.value == 'crypto') {
      this.challenge_step1_input.disabled = true
      this.challenge_step2_input.checked = true

      this.setAccountSizeValues(calculator_config.types.crypto)
    } else {
      this.challenge_step1_input.disabled = false

      this.setAccountSizeValues(calculator_config.types.legacy)
    }
  }

  resetAccountSizeValues = () => {
    this.account_value_inputs.forEach((input) => {
      input.removeAttribute('checked')
    })
  }

  setAccountSizeValues = (data) => {
    let counter = 0

    this.resetAccountSizeValues()

    this.account_value_inputs.forEach((input) => {
      const label = input.nextElementSibling.querySelector('span')
      const value = data.range.steps[counter]

      input.value = value
      label.textContent = this.formatPrice(value)

      if(value == data.range.default){
        input.setAttribute('checked', true)
      }

      counter++;
    })
  }

  formatPrice = (number) => {
    return '$' + Number(number / 1000).toLocaleString() + 'k'
  }
}

new Calculator()
